<h2
  class="fs-xl-sm fw-600 lh-2xl text-gunmetal"
  [ngClass]="resetMarginBottom ? 'mb-0' : 'mb-2'">
  <ng-content></ng-content>
</h2>
